<template>
    <div class="inspection-page">
      <div class="left-form" ref="madeForm">
        <avue-form ref="AvueForm" :option="formOption" v-model="detailForm"  @submit="submit" ></avue-form>
      </div>
    </div>
  </template>
  
  <script>
  import { disposeDetail } from '@/basic-common/util/common.js';
  export default {
    data () {
      return {
        detailForm:{},
        formOption: {
          ...this.$store.state.formOption,
          menu: false,
          span: 24,
          submitBtn:false,
          emptyBtn:false,
          edit: true,
          column: [
            { 
              label: '审核意见', 
              prop: 'auditOpinion',
              type: 'textarea',
              maxlength: 500,
              rows: 4,
              placeholder: '审核意见'
            },
            {
              label: "审核结果",
              prop: "auditResult",
              type: "select",
              dicData: [
                { label: '通过', value: '1' },
                { label: '拒绝', value: '2' },
              ],
              placeholder: '请选择结果'
            },
          ],
        },
      };
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        disposeDetail(this.$refs.madeForm)
      },
      echoData() {
        this.$refs.AvueForm.validate((valid,done,msg) => {
          console.log(`👽👽👽👽` , this.detailForm)
          done()
          if (valid) {
            console.log("dDDD")
          }else{
            return false
          }
        })
       
        return this.detailForm
 
    },
    }
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-form__menu {
    display: none;
  }
  .inspection-page {
    display: flex;
    padding: 20px;
    gap: 20px;
    background-color: #fff;
  }
  .left-form {
    flex: 1;
  }
  </style>